module.exports = __webpack_public_path__ + "img/code_wx.07a4e4ef.png";